export default __webpack_public_path__ + "static/media/after_me.92739e2d.webp";